module.exports = __webpack_public_path__ + "static/img/3areaA_2.aab2c58.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/3areaA_2.png
// module id = 1026
// module chunks = 1